import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class MessageService {

  public subject = new Subject<any>();

  public subject2 = new Subject<any>();

  private dataSource: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  data: Observable<string> = this.dataSource.asObservable();

  private dataSource1: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  importType: Observable<string> = this.dataSource1.asObservable();

  sendMessage(message: any) {
    this.dataSource1.next(message);
  }

  sendData(message: any) {
    this.dataSource.next(message)

  }

  clearMessages() {
    this.dataSource1.next("");
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  public sendMsgToTimepickerComp(message: any) {
    this.subject2.next({ text: message });
  }

  getMsgInTimepickerComp(): Observable<any> {
    return this.subject2.asObservable();
  }
}
